import React from "react";

import CheckIcon from "@uui/Check";
import EditIcon from "@uui/Edit02";
import CloseIcon from "@uui/XClose";

import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Stack, { StackProps } from "@mui/material/Stack";
import styled from "@mui/material/styles/styled";

type WrapperProps = StackProps & { editing: boolean };
export const Wrapper = styled<React.FC<WrapperProps>>(
  ({ editing: _e, ...props }) => (
    <Stack direction="row" spacing={1} {...props} />
  )
)(({ theme, editing }) => ({
  alignItems: "center",
  borderRadius: "6px",
  position: "relative",
  width: "fit-content",
  minHeight: "24px",
  "& .MuiIconButton-root": {
    transition: "opacity 200ms",
    opacity: editing ? 1 : 0,
  },
  "&.editable-typography--clickable": {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: editing ? undefined : theme.palette.shades.ghost[400],
      "& .MuiIconButton-root": {
        opacity: 1,
      },
    },
  },
}));

const ICON_BUTTON_STYLES = {
  borderRadius: "6px",
  width: "24px",
  height: "24px",
  transition: "all 0.1s !important",
};

export const EditButton = styled(
  ({ editing, ...props }: IconButtonProps & { editing: boolean }) => (
    <IconButton {...props}>
      {editing ? (
        <CheckIcon sx={{ height: "14px", width: "14px" }} />
      ) : (
        <EditIcon sx={{ height: "14px", width: "14px" }} />
      )}
    </IconButton>
  )
)(({ theme, editing }) => ({
  ...ICON_BUTTON_STYLES,
  color: editing ? "#fff" : theme.palette.shades.neutral[300],
  backgroundColor: editing
    ? theme.palette.shades.meadow[500]
    : theme.palette.shades.ghost[400],
  "&.hidden": { display: "none" },
  "&:hover": {
    color: editing ? "#fff" : theme.palette.shades.primary[500],
    backgroundColor: editing
      ? theme.palette.shades.meadow[400]
      : theme.palette.shades.ghost[400],
  },
}));

export const CloseButton = styled((props: IconButtonProps) => (
  <IconButton {...props}>
    <CloseIcon sx={{ height: "14px", width: "14px" }} />
  </IconButton>
))(({ theme }) => ({
  ...ICON_BUTTON_STYLES,
  color: "#fff",
  backgroundColor: theme.palette.shades.negative[400],
  "&:hover": {
    color: "#fff",
    backgroundColor: theme.palette.shades.negative[300],
  },
}));
